import { useEffect, useState } from 'react';
import { getRequestDetail } from '../../../services/ApiGetRequestDetail';
import { AdvanceSalaryRespone } from '../../../model/datatype';
import { Container, Row, Col } from 'react-bootstrap';
import Moment from 'moment';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const PayrollCutoff = () => {
  const timezoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone || 'FallbackTimeZone';
  const [data, setData] = useState<AdvanceSalaryRespone | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  let navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    
    const fetchData = async () => {
      setIsLoading(true);
      
      try {
        // ตรวจสอบข้อมูลจาก cache ก่อน
        const cachedData = sessionStorage.getItem('salary_request_detail_cache');
        const cacheTimestamp = sessionStorage.getItem('salary_request_detail_timestamp');
        
        // ใช้ cache ถ้ามีอายุน้อยกว่า 5 นาที
        const isCacheValid = cacheTimestamp && 
                            Date.now() - parseInt(cacheTimestamp) < 5 * 60 * 1000;
                            
        if (cachedData && isCacheValid) {
          if (isMounted) {
            setData(JSON.parse(cachedData));
            setIsLoading(false);
            return;
          }
        }
        
        // ถ้าไม่มีหรือ cache หมดอายุ ดึงข้อมูลใหม่
        const response = await getRequestDetail();
        if (isMounted) {
          // บันทึก cache
          sessionStorage.setItem('salary_request_detail_cache', JSON.stringify(response));
          sessionStorage.setItem('salary_request_detail_timestamp', Date.now().toString());
          
          setData(response);
          setError('');
        }
      } catch (err) {
        if (isMounted) {
          console.error('Error fetching salary request data:', err);
          setError('Failed to load data');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  let { t } = useTranslation();
  if (localStorage.getItem('Language') === 'en') {
    Moment.locale('en-sg');
  } else {
    Moment.locale('th');
  }

  const renderStatus = () => {
    switch (data?.advanceSalaryRequest?.status) {
      case 0:
        return <button className="payroll-status-pending">Pending</button>;
      case 1:
        return <button className="payroll-status-approved">Approved</button>;
      case 9:
        return <button className="payroll-status-rejected">Rejected</button>;
      default:
        return '';
    }
  };
  const handleGoToDetail = () => {
    navigate('/salary/');
  };

  return (
    <>
      {data?.advanceSalaryRequest && Object.keys(data?.advanceSalaryRequest).length > 0 ? (
        <div className="time-detail-box" onClick={() => handleGoToDetail()}>
          <Container>
            <Row>
              <Col className=" px-1">
                <div className="PayrollCutoff-download mt-2">
                  <Row>
                    <Col>
                      <div className="Payroll-calendar">
                        <div className="payroll-img">
                          <img alt='calendar' src="../images/calendar-icon.svg" />
                        </div>
                        <div className="home-payroll-date">
                          <span>
                           
                            {moment(
                              data?.advanceSalaryRequest?.requestDate,
                            )
                              .tz(timezoneStr)
                              .format('DD MMM YYYY')}
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col>{renderStatus()}</Col>
                  </Row>
                  <Row>
                    <Col xs={8} className="mt-2">
                      <div className="payroll-money ">
                        {t('adv_salary_request.title')}
                      </div>
                    </Col>
                    <Col xs={4} className="mt-2 text-end">
                      {data?.advanceSalaryRequest?.requestAmountStr}{' '}
                      {t('adv_salary_request.unit')}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        ''
      )}
    </>
  );
};
